import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const studentAssessmentLandscapeImageFragment = gql`
  fragment StudentAssessmentLandscapeImageFragment on Assessment {
    landscapeImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;

export const studentAssessmentSquareImageFragment = gql`
  fragment StudentAssessmentSquareImageFragment on Assessment {
    squareImage {
      ...ResponsiveImageFragment
    }
  }
  ${ResponsiveImageFragment}
`;
